import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  dynamicMiddleware,
  rootReducer,
  type RootState,
} from "@momentum/redux-store";
import type { WithSlice } from "@reduxjs/toolkit/react";

export const momentumApi = createApi({
  reducerPath: "momentumApi",
  tagTypes: ["ScoresFeed", "GameState", "Pbp"],
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_MOMENTUM_API_BASE_URL,
  }),
  endpoints: () => ({}),
});

rootReducer.inject(momentumApi);

declare module "@momentum/redux-store" {
  export interface LazyLoadedSlices extends WithSlice<typeof momentumApi> {}
}

dynamicMiddleware.addMiddleware(momentumApi.middleware);

export const selectMomentumApiSlice = (state: RootState) => state.momentumApi;
